document.addEventListener('turbolinks:load', () => {
  const initializeColumnVisibility = () => {
    const checkboxes = document.querySelectorAll('.column-toggle');
    const hiddenColumns = Array.from(checkboxes)
      .filter(checkbox => !checkbox.checked)
      .map(checkbox => checkbox.id.replace('column_', ''));
    localStorage.setItem('hiddenColumns', JSON.stringify(hiddenColumns));
    applyColumnVisibility();
  };

  const toggleColumns = () => {
    const checkboxes = document.querySelectorAll('.column-toggle');
    const hiddenColumns = Array.from(checkboxes)
      .filter(checkbox => !checkbox.checked)
      .map(checkbox => checkbox.id.replace('column_', ''));
    localStorage.setItem('hiddenColumns', JSON.stringify(hiddenColumns));
    applyColumnVisibility();
  };

  const applyColumnVisibility = () => {
    const hiddenColumns = JSON.parse(localStorage.getItem('hiddenColumns') || '[]');
    const tables = document.querySelectorAll('.accordion-body table');
    tables.forEach(table => {
      const columns = table.querySelectorAll('th, td');
      columns.forEach(cell => {
        const columnNames = Array.from(cell.classList).filter(className =>
            className !== 'align-middle' && className !== 'power_plant' && className !== 'voltage-rank'
        );

        if (columnNames.some(name => hiddenColumns.includes(name))) {
          cell.style.display = 'none';
        } else {
          cell.style.display = '';
        }

      });
      adjustColspans(table);
    });
  };

  const adjustColspans = (table) => {
    const headerRow = table.querySelector('thead tr:first-child');
    const groupHeaders = headerRow.querySelectorAll('th[data-group]');
    const subHeaderRow = table.querySelector('thead tr:nth-child(2)');
    
    groupHeaders.forEach(header => {
      const groupName = header.getAttribute('data-group');
      // Find all sub-columns with matching data-group
      const subColumns = subHeaderRow.querySelectorAll(`th[data-group="${groupName}"]`);
      
      // Count visible sub-columns
      const visibleCount = Array.from(subColumns).reduce((count, subHeader) => {
        return count + (subHeader.style.display !== 'none' ? 1 : 0);
      }, 0);
      
      // Update colspan
      if(visibleCount == 0){
        header.style.display = 'none';
      }else{
        header.style.display = '';
        header.setAttribute('colspan', Math.max(visibleCount, 1));
      }
    });
  };

  initializeColumnVisibility();

  document.querySelectorAll('.column-toggle').forEach(checkbox => {
    checkbox.addEventListener('change', toggleColumns);
  });

  const accordionObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const accordionBody = mutation.target.querySelector('.accordion-body');
        if (accordionBody && !accordionBody.classList.contains('loading')) {
          applyColumnVisibility();
        }
      }
    });
  });

  document.querySelectorAll('.accordion-collapse').forEach(accordionItem => {
    accordionObserver.observe(accordionItem, { attributes: true, subtree: true, childList: true });
  });
});
